import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import { Circle } from '@bubble-ui/primitive-circle';
import Shape from '@bubble-ui/primitive-shape';
import Group from '@bubble-ui/primitive-group';
import Rect from '@bubble-ui/primitive-rect';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import ClipPath from '@bubble-ui/primitive-clip-path';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var PaymentLogoBlik = _ref => {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoBlik',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 42,
    height: 22,
    fill: "none",
    viewBox: "0 0 42 22"
  }, props), /*#__PURE__*/React.createElement(Group, {
    clipPath: "url(#clip0_6449_1384)"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 41.814,
    height: 22,
    fill: "url(#paint0_linear_6449_1384)",
    rx: 3
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M20.053 19.176h-2.836V3.29h2.836v15.885ZM25.314 19.176h-2.836V8.654h2.836v10.522ZM38.022 19.176l-4.26-5.568 3.918-4.954h-3.348l-3.758 4.806V3.29H27.74v15.886h2.835v-5.402l3.758 5.402h3.69ZM9.992 16.46a2.545 2.545 0 1 1 0-5.09 2.545 2.545 0 0 1 0 5.09Zm0-7.926c-.92 0-1.787.232-2.545.64V3.291H4.612v10.624a5.38 5.38 0 1 0 5.38-5.38Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 12.759,
    cy: 5.033,
    r: 2.528,
    fill: "url(#paint1_linear_6449_1384)",
    transform: "rotate(-180 12.76 5.033)"
  })), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_6449_1384",
    x1: 20.907,
    x2: 20.907,
    y1: 0,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, null), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#404344"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_6449_1384",
    x1: 11.138,
    x2: 14.437,
    y1: 2.853,
    y2: 7.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#E73E96"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#E73E96"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.54,
    stopColor: "#EF454D"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#EE322F"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_6449_1384"
  }, /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M0 0h41.814v22H0z"
  }))));
};
PaymentLogoBlik.displayName = 'PaymentLogoBlik';
export default withProvisionalOverrideFromContext(PaymentLogoBlik);
//# sourceMappingURL=index.js.map